export { default as CoverLoader } from './cover-loader';
